<div class="bg-body-secondary">
  <div class="container">
    <div class="row g-3 g-lg-0 py-4">
      <div class="col-lg-3">
        <div class="d-flex flex-lg-column gap-4 gap-lg-0 overflow-hidden">
          @for (item of progressList; track item) {
            <div
              [id]="'step-' + item.step"
              class="d-flex flex-column flex-lg-row align-items-center gap-2"
            >
              <span class="badge text-bg-light border p-2">
                <img
                  [src]="'/assets/icons/' + item.icon + '.svg'"
                  [class]="{ 'disabled-icon': item.step !== step }"
                  alt=""
                />
              </span>
              <div
                class="text-nowrap text-center text-lg-start"
                [class]="{ 'text-body-tertiary': item.step !== step }"
              >
                <span class="fw-semibold">{{ item.title }}</span>
                <br />
                {{ item.subtitle }}
              </div>
            </div>

            @if ($index < progressList.length - 1) {
              <div class="vertical-line d-none d-lg-block"></div>
            }
          }
        </div>
      </div>

      <div class="col-lg-6 d-flex justify-content-center align-items-center">
        <div class="card overflow-auto" style="width: 28rem; height: 36rem">
          @if (loading) {
            <div
              class="d-flex justify-content-center align-items-center h-100 fade-in"
            >
              <div class="spinner-border" role="status">
                <span class="visually-hidden">Cargando...</span>
              </div>
            </div>
          } @else {
            @switch (step) {
              @case (1) {
                <ng-container *ngTemplateOutlet="stepOne"></ng-container>
              }
              @case (2) {
                <ng-container *ngTemplateOutlet="stepTwo"></ng-container>
              }
              @case (3) {
                <ng-container *ngTemplateOutlet="stepThree"></ng-container>
              }
              @case (4) {
                <ng-container *ngTemplateOutlet="stepFour"></ng-container>
              }
            }
          }
        </div>
      </div>

      <div class="col-md-3 d-none d-md-block"></div>
    </div>
  </div>
</div>

<ng-template #stepOne>
  <div class="card-body fade-in d-flex flex-column justify-content-between">
    <div>
      <h4>¡Bienvenido al proceso de pre-inscripción!</h4>

      <p>
        Te pediremos información sobre la persona interesada en inscribirse en
        la Universidad del Deporte de Puebla. Lee cuidadosamente cada sección y
        completa todos los campos de manera precisa.
      </p>

      <p class="fw-semibold">
        ¡Te deseamos éxito en tu proceso de pre-inscripción!
      </p>
    </div>

    <div class="d-grid">
      <button class="btn btn-primary" (click)="goToStep(2)">Continuar</button>
    </div>
  </div>
</ng-template>

<ng-template #stepTwo>
  <div class="card-body fade-in">
    <button class="btn p-0 mb-3" (click)="goToStep(1)">
      <img src="/assets/icons/arrow_left_short.svg" alt="" />
      <span class="text-body-secondary">Volver</span>
    </button>

    <h6 class="text-body-secondary mb-3">
      Complete todo el formulario antes de continuar:
    </h6>

    <form [formGroup]="formGroupOne" class="row g-2">
      <div class="col-12">
        <label for="first_name" class="form-label">Nombre(s)</label>
        <input
          class="form-control"
          [class]="{ 'is-invalid': checkValidation(1, 'first_name') }"
          id="first_name"
          formControlName="first_name"
          (keypress)="onlyText($event)"
        />
        <div class="invalid-feedback">
          El nombre debe tener al menos 3 caracteres
        </div>
      </div>

      <div class="col-sm-6">
        <label for="last_name_father" class="form-label">
          Apellido Paterno
        </label>
        <input
          class="form-control"
          [class]="{ 'is-invalid': checkValidation(1, 'last_name_father') }"
          id="last_name_father"
          formControlName="last_name_father"
          (keypress)="onlyText($event)"
        />
        <div class="invalid-feedback">
          El apellido debe tener al menos 3 caracteres
        </div>
      </div>

      <div class="col-sm-6">
        <label for="last_name_mother" class="form-label">
          Apellido Materno
        </label>
        <input
          class="form-control"
          [class]="{ 'is-invalid': checkValidation(1, 'last_name_mother') }"
          id="last_name_mother"
          formControlName="last_name_mother"
          (keypress)="onlyText($event)"
        />
        <div class="invalid-feedback">
          El apellido debe tener al menos 3 caracteres
        </div>
      </div>

      <div class="col-12">
        <label for="gender" class="form-label">Sexo</label>
        <select id="gender" class="form-select" formControlName="gender">
          <option value="" selected disabled>Seleccionar</option>
          @for (gender of genders; track gender) {
            <option value="{{ gender }}">{{ gender }}</option>
          }
        </select>
      </div>

      <div class="col-12">
        <label for="birth_date" class="form-label">Fecha De Nacimiento</label>
        <input
          type="date"
          class="form-control"
          id="birth_date"
          formControlName="birth_date"
        />
      </div>

      <div class="col-12">
        <label for="state_of_origin" class="form-label">Estado de origen</label>
        <select
          id="state_of_origin"
          class="form-select"
          (change)="getMunicipalities($event, 1)"
          formControlName="state_of_origin"
        >
          <option value="" selected disabled>Seleccionar</option>
          @for (state of states; track state.id) {
            <option value="{{ state.name }}">{{ state.name }}</option>
          }
        </select>
      </div>

      <div class="col-12">
        <label for="municipality_origin" class="form-label">
          Municipio de origen
        </label>
        <select
          id="municipality_origin"
          class="form-select"
          formControlName="municipality_origin"
        >
          <option value="" selected disabled>Seleccionar</option>
          @for (municipality of municipalities; track municipality.id) {
            <option value="{{ municipality.name }}">
              {{ municipality.name }}
            </option>
          }
        </select>
      </div>

      <div class="d-grid mt-4">
        <button
          class="btn btn-primary"
          (click)="saveUser()"
          [disabled]="formGroupOne.invalid"
        >
          Continuar
        </button>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #stepThree>
  <div class="card-body fade-in">
    <button
      class="btn p-0 mb-3"
      data-bs-toggle="modal"
      data-bs-target="#goStepTwoModal"
    >
      <img src="/assets/icons/arrow_left_short.svg" alt="" />
      <span class="text-body-secondary">Volver</span>
    </button>

    <h6 class="text-body-secondary mb-3">
      Complete todo el formulario antes de continuar:
    </h6>

    <form [formGroup]="formGroupTwo" class="row g-2">
      <div class="col-12">
        <label for="favorite_sport" class="form-label">
          ¿Cuál es tu deporte favorito?
        </label>
        <select
          id="favorite_sport"
          class="form-select"
          formControlName="favorite_sport"
        >
          <option value="" selected disabled>Seleccionar</option>
          @for (sport of sports; track sport) {
            <option value="{{ sport }}">{{ sport }}</option>
          }
        </select>
      </div>

      <div class="col-sm-6">
        <label for="contact_phone" class="form-label">Teléfono</label>
        <div class="input-group">
          <span class="input-group-text bg-transparent border-end-0 pe-1 ps-2">
            <img src="/assets/icons/phone_fill.svg" alt="" />
          </span>
          <span
            class="input-group-text text-body-secondary bg-transparent border-start-0 border-end-0 px-1"
            id="code"
          >
            +52
          </span>
          <input
            class="form-control rounded-end border-start-0 ps-1"
            [class]="{ 'is-invalid': checkValidation(2, 'contact_phone') }"
            id="contact_phone"
            placeholder="XXXXXXXXXX"
            formControlName="contact_phone"
            maxlength="10"
            (keypress)="onlyNumber($event)"
          />
          <div class="invalid-feedback">Deben ser 10 dígitos</div>
        </div>
      </div>

      <div class="col-sm-6">
        <label for="contact_email" class="form-label">Correo de Contacto</label>
        <input
          type="email"
          class="form-control"
          [class]="{ 'is-invalid': checkValidation(2, 'contact_email') }"
          id="contact_email"
          placeholder="correo@mail.com"
          formControlName="contact_email"
        />
        <div class="invalid-feedback">Correo inválido; verificar</div>
      </div>

      <div class="col-12">
        <label for="education_program_id" class="form-label">
          ¿Qué Licenciatura Te Interesa Más?
        </label>
        <select
          id="education_program_id"
          class="form-select"
          formControlName="education_program_id"
        >
          <option value="" selected disabled>Seleccionar</option>
          @for (program of programs; track program.id) {
            <option value="{{ program.id }}">{{ program.name }}</option>
          }
        </select>
      </div>

      <div class="col-12 mt-4">
        <label for="tutor_authorization" class="form-label">
          ¿Cuentas Con La Autorizacion De Tu Tutor Para Proporcionar Los Datos
          Anteriores?
        </label>
        <div class="form-check">
          <input
            type="checkbox"
            class="form-check-input"
            id="tutor_authorization"
            formControlName="tutor_authorization"
          />
          <label class="form-check-label" for="tutor_authorization">
            Sí, cuento con la autorización de mi tutor.
          </label>
        </div>
      </div>

      <p class="mb-0 mt-4">Aviso Legal</p>
      <p class="text-body-secondary">
        Los datos aquí solicitados serán usados exclusivamente para fines de
        comunicación e información sobre los planes de estudio de la UDEP.
        Consulta nuestro aviso de privacidad en nuestro sitio web.
      </p>
    </form>
  </div>

  <div class="card-footer bg-transparent border-0 mb-3 mx-3 fade-in">
    <div class="d-grid">
      <button
        class="btn btn-primary"
        (click)="sendData()"
        [disabled]="formGroupTwo.invalid"
      >
        Continuar
      </button>
    </div>
  </div>
</ng-template>

<ng-template #stepFour>
  <div
    class="card-body d-flex flex-column justify-content-center align-items-center fade-in"
  >
    <img src="/assets/icons/check2_circle_2.svg" alt="" />
    <h4 class="text-center fw-bold">Pre-inscripción completada</h4>

    <p class="text-body-secondary text-center">
      Muchas gracias por tu interés en la Universidad del Deporte Puebla.
      Permanece atento a tu correo y teléfono de contacto, pues en breve te
      estaremos buscando.
    </p>
  </div>
</ng-template>

<app-confirm-modal
  modalId="goStepTwoModal"
  message="Perderás todos tus datos ingresados"
  (clicked)="goStepTwo()"
></app-confirm-modal>
